export default {
  namespaced: true,

  state: () => ({
    status: 200, // ставим на ssr этот статус для 404
  }),

  getters: {
    status: state => state.status,
  },

  actions: {
  },

  mutations: {
    setStatus: (state, status = 200) => {
      state.status = status;
    },
  },
};
